import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import ExplainHeader from '~/component/login/H5/ExplainHeader';
import './index.less';

const successMsg = '基于安全考虑，在成功访问对应应用后，请及时关闭当前浏览器';

const LoginSuccess = props => {
    const {agent: {isMobile}} = props;
    return (
        isMobile
            ? (
                <div className="h5-login-success-wrapper">
                    <ExplainHeader class="success-explain">单点登录系统</ExplainHeader>
                    <div className="h5-login-success-modal">
                        <div className="h5-login-success-content-wrapper">
                            <img
                                srcSet="/assets/login-success.png,
                                        /assets/login-success@2x.png 2x,
                                        /assets/login-success@3x.png 3x,"
                                src="/assets/login-success.png" alt="login-success"
                            />
                            <p className="img-explain">登录成功</p>
                            <p>
                                {successMsg}
                            </p>
                        </div>
                    </div>
                </div>
            )
            : (
                <div className="web-login-success-modal">
                    <h1>登录成功</h1>
                    <img
                        srcSet="/assets/login-success.png,
                                /assets/login-success@2x.png 2x,
                                /assets/login-success@3x.png 3x,"
                        src="/assets/login-success.png" alt="login-success"
                    />
                    <p>
                        {successMsg}
                    </p>
                </div>
            )
    );
};

LoginSuccess.propTypes = {
    agent: PropTypes.shape({
        isMobile: PropTypes.bool.isRequired
    }).isRequired,
};

export default connect(({agent}) => ({agent}))(LoginSuccess);
